import dayjs from "dayjs";
import {
  PlannerSlot,
  PLANNER_RANGE_DASH,
} from "@/components/appointmentRequest/assignmentPlanner/assignmentPlan";
import styles from "@/components/appointmentRequest/assignmentPlanner/planner.module.css";

export default function PlannerSlotTime({ slot }: { slot: PlannerSlot }) {
  return (
    <span className={styles.time}>
      <span>{dayjs(slot.start_date).format("HH:mm")}</span>
      <span>{PLANNER_RANGE_DASH}</span>
      <span>{dayjs(slot.end_date).format("HH:mm")}</span>
    </span>
  );
}
